import { Color } from '@lsq-frontend/common-ui';

export enum RequestFundsStatus {
    Submitted = 1,
    UnderReview = 2,
    Approved = 3,
    Declined = 4,
    PartiallyFunded = 5,
    Funded = 6,
    Cancelled = 7,
    Merged = 8
}

export interface IRequestFundsStatusInformation {
    statusText: string;
    color: Color;
    tooltip: string;
}

export class RequestFundsStatusInformation {
    public static Submitted: IRequestFundsStatusInformation = {
        statusText: 'Submitted',
        color: Color.Yellow,
        tooltip: 'Your request has not been reviewed by LSQ yet.'
    };

    public static UnderReview: IRequestFundsStatusInformation = {
        statusText: 'Under Review',
        color: Color.Yellow,
        tooltip: 'Your request is currently being reviewed by LSQ.'
    };

    public static Approved: IRequestFundsStatusInformation = {
        statusText: 'Approved',
        color: Color.Yellow,
        tooltip: 'Your request has been approved and funds will be dispatched shortly.'
    };

    public static Declined: IRequestFundsStatusInformation = {
        statusText: 'Declined',
        color: Color.Red,
        tooltip: 'Your request has been declined.'
    };

    public static PartiallyFunded: IRequestFundsStatusInformation = {
        statusText: 'Partially Funded',
        color: Color.Green,
        tooltip:
            'Your request has been approved for an amount less than you requested and funds are on their way to your account.'
    };

    public static Funded: IRequestFundsStatusInformation = {
        statusText: 'Funded',
        color: Color.Green,
        tooltip: 'Your request for funding has been approved and processed.'
    };

    public static Cancelled: IRequestFundsStatusInformation = {
        statusText: 'Cancelled',
        color: Color.Gray,
        tooltip: 'You have canceled this funding request.'
    };

    public static Merged: IRequestFundsStatusInformation = {
        statusText: 'Merged',
        color: Color.Green,
        tooltip:
            'Your request has been combined with your recent upload of invoices.  Please view your Fundings report.'
    };
}
